import React from 'react';
import { NotificationBanner } from '../elements-banner/notification-banner';
import ReduxBanner from '../elements-banner/ReduxBanner';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const ManageAddonsBanner = ({ intl }) => {
  return (
    <ReduxBanner>
      <NotificationBanner
        outerBannerClass="fixed-banner"
        bannerId="addonsSaveSuccess"
        timing={2}
        message={
          <div className="flex middle center text-white">
            <div><i className="ico icon-yes" /></div>
            <div className="margin-md-left">
              <FormattedMessage
                id="hosting.add_ons_banner.add_on_item_saved"
                defaultMessage="Add-on item saved"
              />
            </div>
          </div>
        }
      />
      <NotificationBanner
        outerBannerClass="fixed-banner"
        bannerId="addonsEditSuccess"
        timing={2}
        message={
          <div className="flex middle center text-white">
            <div><i className="ico icon-yes" /></div>
            <div className="margin-md-left">
              <FormattedMessage
                id="hosting.add_ons_banner.add_on_item_modified"
                defaultMessage="Add-on item modified"
              />
            </div>
          </div>
        }
      />
      <NotificationBanner
        outerBannerClass="fixed-banner"
        bannerId="addonsDeleteSuccess"
        timing={2}
        message={
          <div className="flex middle center text-white">
            <div><i className="ico icon-yes" /></div>
            <div className="margin-md-left">
              <FormattedMessage
                id="hosting.add_ons_banner.add_on_item_deleted"
                defaultMessage="Add-on item deleted"
              />
            </div>
          </div>
        }
      />
      <NotificationBanner
        outerBannerClass="fixed-banner"
        customClass="error-banner"
        timing={2}
        bannerId="addonsDeleteError"
        message={
          <div className="flex middle center text-white">
            <div>
              <img className="ico warning-sign" src="/web-hosting/assets/images/warning-sign.svg?v=rb" alt={intl.formatMessage({ id: 'hosting.add_ons_banner.warning_image_alt', defaultMessage: 'warning sign' })} />
            </div>
            <div className="margin-md-left">
              <FormattedMessage
                id="hosting.add_ons_banner.delete_error_message"
                defaultMessage="We couldn’t delete at this time. Please try again."
              />
            </div>
          </div>
        }
      />
    </ReduxBanner>
  );
};
ManageAddonsBanner.propTypes = {
  intl: intlShape
};

export default injectIntl(ManageAddonsBanner);
